/* ============================================================
   woody® — Varia-Kacheln: Preis der gezeigten Farbe
   ------------------------------------------------------------
   Problem: Die App Varia (Gravity Apps) tauscht auf Kollektionsseiten bei
   Farbkacheln nur Bild, Titel und Link auf eine Variante (?variant=<id>).
   Der Preisblock bleibt der des ganzen Produkts (günstigster Preis, "Ab").

   Dieses Skript setzt auf jeder Kachel, deren Link eine variant-Id traegt,
   Preis, Streichpreis und Spare-Betrag der verlinkten Variante (ohne "Ab").
   Kacheln ohne variant im Link bleiben unveraendert.

   EINBAU: sections/main-collection.liquid, neben dem jquery.range-Script:
     <script src="{{ 'woody-varia-price.js' | asset_url }}" defer="defer"
             data-save="{{ 'woody.card.save' | t: amount: '__AMOUNT__' | escape }}"></script>
   Der Spare-Text kommt so in der Sprache der Seite aus der Uebersetzung
   woody.card.save; "__AMOUNT__" wird durch den Betrag ersetzt.

   Datenquelle: /products/<handle>.js (pro Handle einmal, Pfad mit
   Shopify.routes.root, damit /en/ funktioniert). Geldformat wie im Bestand:
   Shopify.formatMoney + theme.moneyFormat ("EUR <span>228,00</span>").
   ============================================================ */
(function () {
  'use strict';
  if (window.__wvpReady) return;
  window.__wvpReady = true;

  var script = document.currentScript || document.querySelector('script[src*="woody-varia-price"]');
  var saveTpl = (script && script.getAttribute('data-save')) || '';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {}; // handle -> Promise<Produkt|null>
  var timer = null;

  function money(cents) {
    var fm = window.Shopify && window.Shopify.formatMoney;
    var fmt = window.theme && window.theme.moneyFormat;
    return (fm && fmt) ? fm(cents, fmt) : null;
  }

  function plain(html) {
    return html.replace(/<[^>]*>/g, '');
  }

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function ref(tile) {
    var link = tile.querySelector('a.grid-view-item__title') || tile.querySelector('a.gimg-link');
    var href = link ? (link.getAttribute('href') || '') : '';
    var v = href.match(/[?&]variant=(\d+)/);
    var h = href.match(/\/products\/([^\/?#]+)/);
    return (v && h) ? { variant: v[1], handle: h[1] } : null;
  }

  function render(meta, v) {
    var price = money(v.price);
    if (!price) return false;
    var hasCmp = v.compare_at_price > v.price;
    var cmp = hasCmp ? money(v.compare_at_price) : null;
    var save = hasCmp ? money(v.compare_at_price - v.price) : null;
    if (hasCmp && (!cmp || !save)) return false;

    var old = meta.querySelectorAll('.pr_price, .wsp-card-save');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    var html = hasCmp
      ? '<s class="pr_price regular">' + cmp + '</s><span class="pr_price sale">' + price + '</span>'
      : '<span class="pr_price">' + price + '</span>';
    var hidden = meta.querySelector('.v-hidden');
    if (hidden) hidden.insertAdjacentHTML('afterend', html);
    else meta.insertAdjacentHTML('afterbegin', html);

    if (hasCmp && saveTpl) {
      var pill = document.createElement('span');
      pill.className = 'wsp-card-save';
      pill.textContent = saveTpl.replace('__AMOUNT__', plain(save));
      var sale = meta.querySelector('.pr_price.sale');
      if (sale) sale.parentNode.insertBefore(pill, sale.nextSibling);
    }
    return true;
  }

  function apply(tile) {
    var meta = tile.querySelector('.grid-view-item__meta');
    var r = meta ? ref(tile) : null;
    if (!r) return;
    if (meta.getAttribute('data-wvp') === r.variant || meta.getAttribute('data-wvp-req') === r.variant) return;
    meta.setAttribute('data-wvp-req', r.variant);
    getProduct(r.handle).then(function (p) {
      if (!p || !p.variants) return;
      var now = ref(tile);
      if (!now || now.variant !== r.variant) return; // Varia hat inzwischen umgetauscht
      var v = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === r.variant) { v = p.variants[i]; break; }
      }
      if (!v) return;
      if (render(meta, v)) {
        meta.setAttribute('data-wvp', r.variant);
      } else {
        meta.removeAttribute('data-wvp-req'); // Geldformat noch nicht da: spaeter erneut
        schedule(400);
      }
    });
  }

  function scan() {
    timer = null;
    var tiles = document.querySelectorAll('#Collection .grid-view-item');
    for (var i = 0; i < tiles.length; i++) apply(tiles[i]);
  }

  function schedule(ms) {
    if (!timer) timer = setTimeout(scan, ms || 100);
  }

  // Varia laedt Kacheln nach und tauscht asynchron (Link/Titel/Klasse), Infinite-Scroll haengt neue an.
  new MutationObserver(function () { schedule(100); }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href', 'class']
  });
  window.addEventListener('load', function () { schedule(0); });
  schedule(0);
})();
